import React, { useEffect, useMemo } from 'react';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { TreeSelect } from 'antd';
import { useState } from 'react';
import { useAppDispatch } from '@store/hooks';
import { fetchUnpaidInvoices } from '@store/Finance/AP/ApInvoices/UnpaidInvoicesSlice';
import { fetchUnpaidTransactions } from '@store/Finance/AP/ApInvoices/UnpaidInvoicesSlice';

import { type UnPaymentSchedulesModels } from '@store/Finance/AP/ApInvoices/ApInvoicesModels';
import { Card, CardBody, CardFooter, CardHeader } from '@components/card/card';

//

// export const RefundReceiptComponent: React.FC<{
//   formik: any;
//   onClose: () => void;
//   OperatingUnitOptions: any[];
//   treeCustomerData: any[];
// }> = ({ formik, onClose, OperatingUnitOptions, treeCustomerData }) => {
//   const { values, setFieldValue } = formik;
//   const dispatch = useAppDispatch();
//   const navigate = useNavigate();

//   const [transactions, setTransactions] = useState<any[]>([]);
//   const [selectedTransactions, setSelectedTransactions] = useState<string | null>(null);
//   const [isLoading, setIsLoading] = useState(false);
//   const [fetchError, setFetchError] = useState<string | null>(null);

//   useEffect(() => {
//     if (selectedTransactions) {
//       setSelectedTransactions(null);
//       setTransactions([]);
//       setFetchError(null);
//     }
//   }, [values.peopleId, values.organizationId]);

//   console.log(transactions);

//   const handleGetUnpaidTransactions = async () => {
//     if (!values.organizationId || !values.peopleId) return;

//     setIsLoading(true);
//     setFetchError(null);

//     try {
//       const result = await dispatch(
//         fetchUnpaidTransactions({
//           peopleId: values.peopleId,
//           organizationId: values.organizationId,
//           TransactionType: 'DebitMemo'
//         })
//       ).unwrap();

//       if (result.succeeded) {
//         const TransactionsWithType = result.data.map((transaction: any) => ({
//           ...transaction,
//           transactionType: 'Refund'
//         }));
//         setTransactions(TransactionsWithType);
//         if (result.data.length === 0) {
//           setFetchError('لم يتم العثور على فواتير مرتجعات');
//         }
//       } else {
//         setFetchError('فشل في جلب فواتير المرتجعات');
//       }
//     } catch (error) {
//       console.error('Error fetching refund invoices:', error);
//       setFetchError('فشل في جلب فواتير المرتجعات');
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleRadioChange = (recieptScheduleId: string) => {
//     setSelectedTransactions(recieptScheduleId);
//   };

//   const handleSubmit = () => {
//     if (!selectedTransactions) return;

//     const selectedTransactionData = transactions.find(
//       transaction => transaction.arReceiptScheduleId === selectedTransactions
//     );

//     if (selectedTransactionData) {
//       const formattedTransaction = {
//         id: null,
//         arReceiptScheduleId: selectedTransactionData.arReceiptScheduleId,
//         receiptNum: selectedTransactionData.receiptNum,
//         transactionDate: selectedTransactionData.transactionDate,
//         dueDate: selectedTransactionData.dueDate,
//         transactionAmount: selectedTransactionData.transactionAmount,
//         amount: selectedTransactionData.amount,
//         remainingAmount: selectedTransactionData.remainingAmount,
//         actualRemainingAmount: selectedTransactionData.remainingAmount,
//         transactionType: selectedTransactionData.transactionType
//       };

//       formik?.setFieldValue('scheduleList', [formattedTransaction]);
//       onClose();
//     }
//   };

//   const columns = [
//     {
//       title: '',
//       key: 'radio',
//       render: (value: any, record: any) => (
//         <div className='form-check'>
//           <input
//             type='radio'
//             className='form-check-input'
//             name='refundInvoice'
//             checked={selectedTransactions === record.arReceiptScheduleId}
//             onChange={() => handleRadioChange(record.arReceiptScheduleId)}
//           />
//         </div>
//       )
//     },
//     {
//       title: 'نوع الفاتورة',
//       key: 'transactionType',
//       render: (value: any, record: any) => <span className='badge bg-warning'>مرتجع</span>
//     },
//     // { title: 'رقم الدفع', key: 'receiptNum' },
//     { title: 'رقم الفاتورة', key: 'transactionNum' },
//     { title: 'تاريخ الفاتورة', key: 'transactionDate' },
//     { title: 'مبلغ الفاتورة', key: 'transactionAmount' },
//     { title: 'المبلغ المتبقي', key: 'remainingAmount' },
//     { title: 'تاريخ الاستحقاق', key: 'dueDate' }
//   ];

//   const sortedInvoices = [...transactions].sort((a, b) => {
//     return new Date(a.dueDate).getTime() - new Date(b.dueDate).getTime();
//   });

//   const tableData: any[] = sortedInvoices.map(transaction => ({
//     radio: transaction.arReceiptScheduleId,
//     arReceiptScheduleId: transaction.arReceiptScheduleId,
//     transactionType: transaction.transactionType,
//     receiptNum: transaction.receiptNum,
//     transactionNum: transaction.transactionNum,
//     transactionDate: transaction.transactionDate,
//     transactionAmount: (
//       <span className='fw-bold text-primary'>{Number(transaction.transactionAmount).toLocaleString()}</span>
//     ),
//     remainingAmount: (
//       <span className='fw-bold text-success'>{Number(transaction.remainingAmount).toLocaleString()}</span>
//     ),
//     dueDate: transaction.dueDate
//   }));

//   const selectedTransactionData = transactions.find(
//     transaction => transaction.arReceiptScheduleId === selectedTransactions
//   );
//   const selectedAmount = selectedTransactionData ? selectedTransactionData.remainingAmount : 0;

//   const isFormValid = selectedTransactions !== null;

//   return (
//     <div>
//       <div className='row g-3 mb-4'>
//         <div className='col-lg-6'>
//           <div className='form-group'>
//             <label className='form-label fw-bold'>العميل</label>
//             <TreeSelect
//               showSearch
//               className='w-100'
//               treeLine
//               placeholder='اختر العميل'
//               allowClear
//               treeDefaultExpandAll={false}
//               value={values.peopleId}
//               onChange={option => {
//                 setSelectedTransactions(null);
//                 setTransactions([]);
//                 formik.setFieldValue('peopleId', option === null ? null : option);
//               }}
//               treeData={treeCustomerData}
//               treeNodeFilterProp='title'
//               getPopupContainer={triggerNode => triggerNode.parentNode}
//             />
//           </div>
//         </div>

//         <div className='col-lg-4'>
//           <div className='form-group'>
//             <label className='form-label fw-bold'>الوحدة التشغيلية</label>
//             <Select
//               isSearchable={true}
//               isClearable
//               options={OperatingUnitOptions}
//               value={OperatingUnitOptions?.find((f: any) => f.value === formik.values.organizationId)}
//               onChange={(option: any) => {
//                 setSelectedTransactions(null);
//                 setTransactions([]);
//                 setFieldValue('organizationId', option === null ? null : option.value);
//               }}
//               placeholder='اختر الوحدة التشغيلية'
//               className='react-select-container'
//               classNamePrefix='react-select'
//             />
//           </div>
//         </div>

//         <div className='col-lg-2'>
//           <div className='form-group h-100 d-flex flex-column justify-content-end'>
//             <button
//               disabled={isLoading || !values.organizationId || !values.peopleId}
//               type='button'
//               className='btn btn-sm btn-outline-theme w-100 py-2'
//               onClick={handleGetUnpaidTransactions}
//             >
//               {isLoading ? (
//                 <>
//                   <span className='spinner-border spinner-border-sm me-2' role='status' aria-hidden='true'></span>
//                   جاري التحميل...
//                 </>
//               ) : (
//                 <>
//                   <i className='fas fa-download me-2'></i>
//                   جلب المرتجعات
//                 </>
//               )}
//             </button>
//           </div>
//         </div>
//       </div>

//       {fetchError && (
//         <div className='alert alert-warning d-flex align-items-center mb-4' role='alert'>
//           <i className='fas fa-exclamation-triangle me-2'></i>
//           <div>{fetchError}</div>
//         </div>
//       )}

//       {tableData.length > 0 && (
//         <Card className='mb-4'>
//           <div className='card-header d-flex justify-content-between align-items-center'>
//             <h6 className='mb-0'>
//               <i className='fas fa-rotate-left me-2'></i>
//               قائمة فواتير المرتجعات
//               <span className='badge bg-warning ms-2'>مرتجعات</span>
//             </h6>
//             {/* <div>
//               <span className='badge bg-theme me-2'>فاتورة مختارة: {selectedInvoice ? 1 : 0}</span>
//               <span className='badge bg-success'>المبلغ: {selectedAmount.toLocaleString()}</span>
//             </div> */}
//           </div>

//           <div className='card-body p-0'>
//             <div className='table-responsive'>
//               <table className='table table-hover mb-0'>
//                 <thead className='table-actived fw-bold'>
//                   <tr>
//                     {columns.map((col, index) => (
//                       <th key={index} className='text-center small'>
//                         {col.title}
//                       </th>
//                     ))}
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {tableData.map((row, rowIndex) => (
//                     <tr
//                       key={rowIndex}
//                       className={
//                         selectedTransactions === sortedInvoices[rowIndex].arReceiptScheduleId ? 'table-active' : ''
//                       }
//                     >
//                       {columns.map((col, colIndex) => (
//                         <td key={colIndex} className='text-center align-middle'>
//                           {col.render ? col.render(row[col.key], row) : row[col.key]}
//                         </td>
//                       ))}
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           </div>

//           <div className='card-footer d-flex justify-content-between align-items-center'>
//             <div className='text-muted small'>
//               عرض {tableData.length} من {tableData.length} مرتجع
//             </div>
//             <div className='text-theme fw-bold'>المبلغ المحدد: {selectedAmount.toLocaleString()}</div>
//           </div>
//         </Card>
//       )}

//       <div className='border-top mt-4 pt-4'>
//         <div className='d-flex justify-content-between align-items-center'>
//           <div></div>

//           <div className='d-flex'>
//             <button disabled={!isFormValid} className='btn btn-theme me-2 px-4' onClick={handleSubmit}>
//               <i className='fas fa-rotate-left me-2'></i>
//               استرداد المبلغ
//             </button>

//             <button
//               type='button'
//               className='btn btn-outline-secondary'
//               onClick={() => navigate('/Finance/Ar/ArReceipts', { replace: true })}
//             >
//               <i className='fas fa-times me-2'></i>
//               إلغاء
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

export const RefundReceiptComponent: React.FC<{
  formik: any;
  onClose: () => void;
  OperatingUnitOptions: any[];
  treeCustomerData: any[];
}> = ({ formik, onClose, OperatingUnitOptions, treeCustomerData }) => {
  const { values, setFieldValue } = formik;
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [transactions, setTransactions] = useState<any[]>([]);
  const [selectedTransactions, setSelectedTransactions] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [fetchError, setFetchError] = useState<string | null>(null);

  useEffect(() => {
    if (selectedTransactions) {
      setSelectedTransactions(null);
      setTransactions([]);
      setFetchError(null);
    }
  }, [values.peopleId, values.organizationId]);

  const handleGetUnpaidTransactions = async () => {
    if (!values.organizationId || !values.peopleId) return;

    setIsLoading(true);
    setFetchError(null);

    try {
      const result = await dispatch(
        fetchUnpaidTransactions({
          peopleId: values.peopleId,
          organizationId: values.organizationId,
          TransactionType: 'DebitMemo'
        })
      ).unwrap();

      if (result.succeeded) {
        const TransactionsList = result.data;
        setTransactions(TransactionsList);
        if (TransactionsList.length === 0) {
          setFetchError('لم يتم العثور على فواتير مرتجعات');
        }
      } else {
        setFetchError('فشل في جلب فواتير المرتجعات');
      }
    } catch (error) {
      console.error('Error fetching refund invoices:', error);
      setFetchError('فشل في جلب فواتير المرتجعات');
    } finally {
      setIsLoading(false);
    }
  };

  const handleRadioChange = (recieptScheduleId: string) => {
    setSelectedTransactions(recieptScheduleId);
  };

  // console.log(transactions);

  const handleSubmit = () => {
    if (!selectedTransactions) return;

    const selectedTransactionData = transactions.find(
      transaction => transaction.transactionId === selectedTransactions
    );

    if (selectedTransactionData) {
      formik?.setFieldValue('scheduleList', []);
      formik?.setFieldValue('dibetMemoTransactionId', selectedTransactions);
      formik?.setFieldValue('amount', selectedTransactionData.remainingAmount);

      onClose();
    }
    // if (selectedTransactionData) {
    //   const formattedTransaction = {
    //     id: null,
    //     arReceiptScheduleId: selectedTransactionData.arReceiptScheduleId,
    //     receiptNum: selectedTransactionData.receiptNum,
    //     transactionDate: selectedTransactionData.transactionDate,
    //     dueDate: selectedTransactionData.dueDate,
    //     transactionAmount: selectedTransactionData.transactionAmount,
    //     amount: selectedTransactionData.amount,
    //     remainingAmount: selectedTransactionData.remainingAmount,
    //     actualRemainingAmount: selectedTransactionData.remainingAmount,
    //     transactionType: selectedTransactionData.transactionType
    //   };

    //   formik?.setFieldValue('scheduleList', [formattedTransaction]);
    //   onClose();
    // }
  };

  const sortedTransactions = [...transactions].sort((a, b) => {
    return new Date(a.dueDate).getTime() - new Date(b.dueDate).getTime();
  });

  const selectedTransactionData = transactions.find(
    transaction => transaction.arReceiptScheduleId === selectedTransactions
  );
  const selectedAmount = selectedTransactionData ? selectedTransactionData.remainingAmount : 0;

  const isFormValid = selectedTransactions !== null;

  return (
    <div>
      <div className='row g-3 mb-4'>
        <div className='col-lg-6'>
          <div className='form-group'>
            <label className='form-label fw-bold'>العميل</label>
            <TreeSelect
              showSearch
              className='w-100'
              treeLine
              placeholder='اختر العميل'
              allowClear
              treeDefaultExpandAll={false}
              value={values.peopleId}
              onChange={option => {
                setSelectedTransactions(null);
                setTransactions([]);
                formik.setFieldValue('peopleId', option === null ? null : option);
              }}
              treeData={treeCustomerData}
              treeNodeFilterProp='title'
              getPopupContainer={triggerNode => triggerNode.parentNode}
            />
          </div>
        </div>

        <div className='col-lg-4'>
          <div className='form-group'>
            <label className='form-label fw-bold'>الوحدة التشغيلية</label>
            <Select
              isSearchable={true}
              isClearable
              options={OperatingUnitOptions}
              value={OperatingUnitOptions?.find((f: any) => f.value === formik.values.organizationId)}
              onChange={(option: any) => {
                setSelectedTransactions(null);
                setTransactions([]);
                setFieldValue('organizationId', option === null ? null : option.value);
              }}
              placeholder='اختر الوحدة التشغيلية'
              className='react-select-container'
              classNamePrefix='react-select'
            />
          </div>
        </div>

        <div className='col-lg-2'>
          <div className='form-group h-100 d-flex flex-column justify-content-end'>
            <button
              disabled={isLoading || !values.organizationId || !values.peopleId}
              type='button'
              className='btn btn-sm btn-outline-theme w-100 py-2'
              onClick={handleGetUnpaidTransactions}
            >
              {isLoading ? (
                <>
                  <span className='spinner-border spinner-border-sm me-2' role='status' aria-hidden='true'></span>
                  جاري التحميل...
                </>
              ) : (
                <>
                  <i className='fas fa-download me-2'></i>
                  جلب المرتجعات
                </>
              )}
            </button>
          </div>
        </div>
      </div>

      {fetchError && (
        <div className='alert alert-warning d-flex align-items-center mb-4' role='alert'>
          <i className='fas fa-exclamation-triangle me-2'></i>
          <div>{fetchError}</div>
        </div>
      )}

      {sortedTransactions.length > 0 && (
        <Card className='mb-4'>
          <div className='card-header d-flex justify-content-between align-items-center'>
            <h6 className='mb-0'>
              <i className='fas fa-rotate-left me-2'></i>
              قائمة فواتير المرتجعات
              <span className='badge bg-warning ms-2'>مرتجعات</span>
            </h6>
          </div>

          <div className='card-body p-0'>
            <div className='table-responsive'>
              <table className='table table-hover mb-0'>
                <thead className='table-actived fw-bold'>
                  <tr>
                    <th className='text-center small'></th>
                    <th className='text-center small'>نوع الفاتورة</th>
                    <th className='text-center small'>رقم الفاتورة</th>
                    <th className='text-center small'>تاريخ الفاتورة</th>
                    <th className='text-center small'>مبلغ الفاتورة</th>
                    <th className='text-center small'>المبلغ المتبقي</th>
                    <th className='text-center small'>تاريخ الاستحقاق</th>
                  </tr>
                </thead>
                <tbody>
                  {sortedTransactions.map((transaction, index) => (
                    <tr
                      key={index}
                      className={selectedTransactions === transaction.transactionId ? 'table-active' : ''}
                    >
                      <td className='text-center align-middle'>
                        <div className='form-check'>
                          <input
                            type='radio'
                            className='form-check-input'
                            name='refundInvoice'
                            checked={selectedTransactions === transaction.transactionId}
                            onChange={() => handleRadioChange(transaction.transactionId)}
                          />
                        </div>
                      </td>
                      <td className='text-center align-middle'>
                        <span className='badge bg-warning'>مرتجع</span>
                      </td>
                      <td className='text-center align-middle'>{transaction.transactionNum}</td>
                      <td className='text-center align-middle'>{transaction.transactionDate}</td>
                      <td className='text-center align-middle fw-bold text-primary'>
                        {Number(transaction.transactionAmount).toLocaleString()}
                      </td>
                      <td className='text-center align-middle fw-bold text-success'>
                        {Number(transaction.remainingAmount).toLocaleString()}
                      </td>
                      <td className='text-center align-middle'>{transaction.dueDate}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div className='card-footer d-flex justify-content-between align-items-center'>
            <div className='text-muted small'>
              عرض {sortedTransactions.length} من {sortedTransactions.length} مرتجع
            </div>
            <div className='text-theme fw-bold'>المبلغ المحدد: {selectedAmount.toLocaleString()}</div>
          </div>
        </Card>
      )}

      <div className='border-top mt-4 pt-4'>
        <div className='d-flex justify-content-between align-items-center'>
          <div></div>

          <div className='d-flex'>
            <button disabled={!isFormValid} className='btn btn-theme me-2 px-4' onClick={handleSubmit}>
              <i className='fas fa-rotate-left me-2'></i>
              استرداد المبلغ
            </button>

            <button
              type='button'
              className='btn btn-outline-secondary'
              onClick={() => navigate('/AR/ArReceipts', { replace: true })}
            >
              <i className='fas fa-times me-2'></i>
              إلغاء
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
